module.exports = __webpack_public_path__ + "img/benefit.57eab12c.svg";